import { combineReducers } from 'redux';

import {AUTHENTICATE, LOGIN_ERROR, IMAGE_UPLOAD } from '../actions';

const authenticate = (state = false, action) => {
  switch (action.type) {
    case AUTHENTICATE:
      return action.data;
    default:
      return state;
  }
};

const loginError = (state = false, action) => {
  switch (action.type) {
    case LOGIN_ERROR:
      return action.data;
    default:
      return state;
  }
};

const imageUpload = (state = null, action) => {
  switch (action.type) {
    case IMAGE_UPLOAD:
      return action.data;
    default:
      return state;
  }
};


const reducers = combineReducers({
  authenticate,
  loginError,
  imageUpload,
})

export default reducers;
